import React from 'react';
import RefreshingChart from './RefreshingChart';

const GraphBookingPresenceDayChart = ( props ) => {
	return (
		<RefreshingChart
			{ ...props }
			fetchMethod="fetchBookingsPresentDay"
		/>
	);
};

export default GraphBookingPresenceDayChart;
